import React from 'react';
import Modal from './Modal';
import CalendlyScheduler from './CalendlyScheduler';

interface SchedulingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SchedulingModal: React.FC<SchedulingModalProps> = ({ isOpen, onClose }) => (
  <Modal isOpen={isOpen} onClose={onClose} title="Book a consultation" size="large">
    <CalendlyScheduler />
  </Modal>
);

export default SchedulingModal;
